import React from 'react';
import {FileType} from '../DismissibleAttach';
import {IFileModel} from '@src/@interfaces/models/FIle/IFileModel';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {humanFileSize} from '@src/helpers/humanFileSize';

export default function FileAttach({file, onClick}: {
    file?: FileType & Partial<IFileModel>,
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    size?: FormFieldConfigSize,
}) {
    return file ? <div
            className="file-representation--file w-100 px-2"
            onClick={onClick}
    >
        <div className="file-representation__name" title={file.public_name ?? file.file_name}>
            {file.public_name ?? file.file_name}
        </div>
        <div className="file-representation__size">{humanFileSize(file.file_size ?? 0)}</div>
    </div> : null;
}
